module.exports = __webpack_public_path__ + "static/media/8.1a38dea9.jpg";